import { Context, createContext } from 'react';

import { useRequiredContext } from '@/hooks';

export interface GlobalModalsValue {
  showGlobalShortcutsModal: () => void;
  showCurrentLayoutIndexMap?: () => void;
}

export const GlobalModalsContext: Context<GlobalModalsValue | undefined> = createContext<
  GlobalModalsValue | undefined
>(undefined);

export const useGlobalModalsContext = (): GlobalModalsValue =>
  useRequiredContext({
    context: GlobalModalsContext,
    hookName: 'useGlobalModalsContext',
    providerName: 'a GlobalModalsProvider',
  });
